import {
  EXCLUDE_BASIC_PACKAGE,
  EXCLUDE_PREMIUM_PACKAGE,
  SIDEBAR_WIDTH,
} from "../../constants/constant";
import Header from "../../ui/Header";
import SidebarComponents from "../../ui/SidebarComponents";
import NotFound from "../../../assets/images/not_found.png";
import { useNavigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../constants/muiTheme";
import { Helmet } from "react-helmet-async";

const PageTemplateNew = ({
  header,
  breadcrumb,
  mainComponent,
  pageRole,
  checkOwner,
}) => {
  const navigate = useNavigate();
  const packageStatus = localStorage.getItem("package");
  const roles = localStorage.getItem("roles");
  const titleId = localStorage.getItem("title");

  if (!roles && !packageStatus) {
    navigate("/");
  }

  const isIncludePackage = () => {
    if (Number(packageStatus) === 1 && EXCLUDE_BASIC_PACKAGE.includes(pageRole))
      return false;
    if (
      Number(packageStatus) === 2 &&
      EXCLUDE_PREMIUM_PACKAGE.includes(pageRole)
    )
      return false;
    return true;
  };

  const userHasAccess = () => {
    // has access if user's package status has it & included in its own list of roles
    // TODO: add access for reporting children, discount, pelanggan for exclude basic package
    if ((pageRole === undefined || pageRole === null) && !checkOwner)
      return false;
    if (!isIncludePackage()) return false;
    if (pageRole === 0) return true;
    if (checkOwner !== undefined) return Number(titleId) === 1; // allow access to dashboard, discount, pelanggan, sales, settings if owner

    return roles?.includes(pageRole);
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="text-[12px] text-[#2C3E5D] bg-[#F7F8F9]">
        <Helmet>
          <title>{header && header !== "" ? "OLIN - " + header : "OLIN"}</title>
        </Helmet>

        <div className="flex">
          <SidebarComponents />
          <div
            className={`w-full lg:w-[calc(100%-${SIDEBAR_WIDTH}px)] overflow-hidden`}
          >
            <div className={`${header || breadcrumb ? "p-3 pb-0" : ""}`}>
              <Header />
              <div className="mt-[60px] lg:mt-0">
                {breadcrumb ? <div className="">{breadcrumb}</div> : null}

                <div className="mb-4">
                  <div className="w-full">
                    <p className="text-[24px] font-semibold">
                      {header ? header : ""}
                    </p>
                  </div>
                </div>

                <div>
                  {userHasAccess() ? (
                    <div>{mainComponent}</div>
                  ) : (
                    <div className="flex flex-col items-center justify-center pb-4 h-full min-h-[50vh] ">
                      <div>
                        <img src={NotFound} className="w-[150px]" />
                      </div>
                      <p className="text-xl align-center mt-8">
                        Anda belum memiliki akses ke fitur ini
                      </p>
                      <p className="text-gray-400">
                        {isIncludePackage()
                          ? "Silahkan hubungi owner"
                          : "Silahkan upgrade subscription OLIN anda"}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default PageTemplateNew;
